import {PlanSummary} from './plan-summary';

export class SelectedPlan {
    id: number;
    isCustom: boolean;
    lineOfCoverage: string;

    constructor(planSummary: PlanSummary) {
       this.id = planSummary.id;
       this.isCustom = planSummary.isCustom;
       this.lineOfCoverage = planSummary.lineOfCoverage;
    }
}
